import { Autocomplete, TextField, TextFieldVariants } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  ListRequestOfBaseFilter,
  SkuAvailability,
} from "services/KnowfullyAdminClient";

type SelectSkuAvailabilityMultipleProps = {
  value: string[];
  onChange: (v: string[]) => void;
  variant?: TextFieldVariants;
  disabled?: boolean;
};

const SelectSkuAvailabilityMultiple = ({
  onChange,
  value,
  variant,
  disabled,
}: SelectSkuAvailabilityMultipleProps) => {
  const { skuService } = useGlobalContext();
  const { formatMessage: t } = useIntl();

  const { data, isFetching } = useQuery(
    ["SkuAvailabilities"],
    () =>
      skuService.getSkuAvailabilities(
        ListRequestOfBaseFilter.fromJS({
          sortField: "name",
        })
      )
  );

  const handleChangeMultiple = (_: any, values: SkuAvailability[]) => {
    onChange(values.map((v) => v.id!));
  };

  const availabilities = data?.data ?? [];

  return (
    <Autocomplete
      multiple
      ChipProps={{ size: "small" }}
      options={availabilities}
      getOptionLabel={(option) => option.name ?? "?"}
      value={availabilities.filter((r) => value.includes(r.id!) ?? false)}
      onChange={handleChangeMultiple}
      loading={isFetching}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant}
          label={t({ id: "skuAvailabilityLabel" })}
        />
      )}
    />
  );
};

export default SelectSkuAvailabilityMultiple;
